import React from 'react';
import { DeliveryCarrier } from '../../services/exports/Constants';
import UberEatsIcon from '../../assets/logo/UberEatsIcon';
import WoltIcon from '../../assets/logo/WoltIcon';
import { IconProps } from '../../assets/icons/types';

export interface Props extends IconProps {
  carrier: string;
}

export default function DeliveryCarrierIcon({ carrier, ...props }: Props) {
  return (
    {
      [DeliveryCarrier.Uber]: <UberEatsIcon {...props} />,
      [DeliveryCarrier.Wolt]: <WoltIcon {...props} />,
    }[carrier] ?? null
  );
}
